import { useParams } from "react-router";
import SearchInputHeader from "../../components/search_input/SearchInputHeader";
import { useEffect, useState } from "react";
import { LoadingIcon } from "../../components/LoadingIcon";
import "./itemPage.css";
import { useAuctionHouseCtx } from "@/client/contexts/AuctionHouseProvider";
import ItemHeader from "./ItemHeader";
import ItemCurrent from "./ItemCurrent";
import ItemShortHistory from "./ItemShortHistory";
import HistoryChart from "../../components/history_chart/HistoryChart";
import type { LocalItemEntry } from "@/client/data/ItemCache";
import { getOrLoadItem } from "@/client/data/ItemCache";

const ItemPage = (): JSX.Element => {
    const params = useParams();
    const itemIdParam = params["itemid"]!;
    const itemId = parseInt(itemIdParam);
    const [itemData, setItemData] = useState<LocalItemEntry>();
    const [errorMsg, setErrorMsg] = useState<string>();
    const { selectedAuctionHouse } = useAuctionHouseCtx();

    if (!itemId || isNaN(itemId)) return <>Error: Invalid itemid parameter!</>;

    useEffect(() => {
        setItemData(undefined);
        if (!selectedAuctionHouse) return;
        getOrLoadItem(selectedAuctionHouse, itemId)
            .then((item) => {
                if (!item) return setErrorMsg("Item not found!");
                setItemData(item);
            })
            .catch((err) => {
                setErrorMsg(err instanceof Error ? err.message : String(err));
            });
    }, [selectedAuctionHouse, itemId]);

    if (!itemData || errorMsg) {
        return (
            <>
                <SearchInputHeader />
                <div className="itemPageWrap">
                    {errorMsg ? <>Error: {errorMsg}</> : <LoadingIcon className="pageLoadIcon" />}
                </div>
            </>
        );
    }

    const dataLatest = itemData.data[itemData.data.length - 1];

    return (
        <>
            <SearchInputHeader />
            <div className="itemPageWrap">
                <div className="itemPageSection">
                    <ItemHeader itemData={itemData}></ItemHeader>
                    <div className="itemPageDetails">
                        <ItemCurrent data={dataLatest}></ItemCurrent>
                        <div>
                            <h2 className="itemPageH2">Short Price History</h2>
                            <ItemShortHistory valueName="Min. Buyout" data={itemData.data}></ItemShortHistory>
                        </div>
                    </div>
                </div>
                <div className="itemPageHistoryGraphSection itemPageSection">
                    <HistoryChart data={itemData.data}></HistoryChart>
                </div>
                <div className="itemPageSection"></div>
            </div>
        </>
    );
};

export default ItemPage;
